import { z } from 'zod'

export const trainerXanoFreezeExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoFreezeExceptionResponse = z.infer<typeof trainerXanoFreezeExceptionResponseSchema>
